
<script lang="ts">

    import Asciitable from "../components/Asciitable.svelte"

</script>

<style>

</style>

<main>
	<h1 class="title"  style="color:red;">ASCII Table</h1>

	<hr />

	<p> From <a href="https://en.wikipedia.org/wiki/ASCII">Wikipedia</a>: ASCII, abbreviated from American Standard Code for Information Interchange, is a 
		character encoding standard for electronic communication. ASCII codes represent text in computers, 
		telecommunications equipment, and other devices. Most modern character-encoding schemes are based on ASCII, 
		although they support many additional characters.
		The Internet Assigned Numbers Authority (IANA) prefers the name US-ASCII for this character encoding. </p>

	<hr />

	<div class="columns is-desktop">
		<div class="column is-one-third">
			<Asciitable BaseChar={0} Count={32} />
		</div>
		<div class="column">
			<Asciitable BaseChar={32} Count={32} />
		</div>
		<div class="column">
			<Asciitable BaseChar={64} Count={32} />
		</div>
		<div class="column">
			<Asciitable BaseChar={96} Count={32} />
		</div>
	</div>	
</main>
